<template>
  <div class="subscribe-to-professional">
    <div class="confirm-booking-sub">
      <div
        data-w-id="12ee7c5f-928e-03df-7a7e-615ebf1de4f1"
        @click="cancel"
        href=""
        class="link-block-5 w-inline-block"
      >
        <img
          src="@/assets/timeslot-images/Group-36561.svg"
          loading="lazy"
          alt=""
        />
      </div>
      <div class="title">
        <h1 class="modal-heading">Confirm your Subscription</h1>
      </div>

      <p class="paragraph-7-copy">
        Subscription with
        <a href="" class="link-10">{{ singleProfessional.customerName }}</a>
      </p>
      <div class="div-block-80">
        <div class="div-block-82">
          <div class="div-block-81">
            <img
              src="@/assets/timeslot-images/calendar1.svg"
              loading="lazy"
              alt=""
              class="image-17"
            />
            <div class="text-block-67">
              Every {{ days[0] }}<span v-if="days.length > 1">,</span
              >{{ days[1] }}<span v-if="days.length > 2">,</span>{{ days[2] }}
            </div>
          </div>
          <div class="div-block-81">
            <img
              src="@/assets/timeslot-images/clock1.svg"
              loading="lazy"
              alt=""
              class="image-17"
            />
            <div class="text-block-67">
              {{ selectedSubSlot.availableTimeStartTime.slice(0, 5)
              }}{{ amPm(selectedSubSlot.availableTimeStartTime) }}
              -
              {{ selectedSubSlot.availableTimeEndTime.slice(0, 5)
              }}{{ amPm(selectedSubSlot.availableTimeEndTime) }} ({{
                customerInfo.customerTimezone
              }})
            </div>
          </div>
        </div>
        <div>
          <div class="div-block-81">
            <img
              src="@/assets/timeslot-images/price.svg"
              loading="lazy"
              alt=""
              class="image-17"
            />
            <div class="text-block-67" v-if="subType === 'Monthly'">
              {{ profSubscriptions.monthlySubscriptionAmount }} USD/month
            </div>
            <div class="text-block-67" v-if="subType === 'Weekly'">
              {{ profSubscriptions.weeklySubscriptionAmount }} USD/week
            </div>
          </div>
        </div>
      </div>
      <div class="div-block-83">
        <div class="div-block-84">
          <div class="text-block-68">Enter topic</div>
          <input
            type="text"
            class="text-field-3 w-input"
            maxlength="256"
            name="field-3"
            data-name="Field 3"
            placeholder="e.g Managing burnout"
            id="field-3"
            required=""
            v-model="createModel.subscriptionTopic"
          />
        </div>
        <div>
          <div class="text-block-68">Enter description</div>
          <textarea
            placeholder="Add a description"
            maxlength="5000"
            id="field-2"
            name="field-2"
            data-name="field"
            class="textarea w-input"
            v-model="createModel.subscriptionMessage"
          ></textarea>
        </div>
      </div>
      <BaseComponentLoader
        v-if="loader.nonBlockingLoader"
        loaderAlignment="center"
      />
      <div
        v-else
        data-w-id="12ee7c5f-928e-03df-7a7e-615ebf1de512"
        class="button-15 w-button"
        @click="createSubscription"
      >
        Confirm subscription
      </div>
      <div class="button-15-copy w-button" @click="change">
        Change date &amp; time
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SubscriptionRequest from "@/model/requests/SubscriptionRequest";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";

export default {
  name: "ConfirmSubscriptionModal",
  components: { BaseComponentLoader },
  data() {
    return {
      createModel: SubscriptionRequest.create
    };
  },
  props: {
    cancel: Function,
    days: Array,
    subType: String,
    change: Function,
    daysList: Array
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalInfo: state => state.professional.professionalInfo,
      singleProfessional: state => state.professional.singleProfessional,
      selectedSubSlot: state => state.availability.selectedSubSlot,
      profSubscriptions: state => state.professional.profSubscriptions,
      customerInfo: state => state.customer.customerInfo
    }),
    ...mapState(["loader"])
  },
  methods: {
    shortTimezone(value) {
      let timeStrings = value.split(" ");
      let newList = timeStrings.map(item => item[0]).join("");
      return newList;
    },
    amPm(value) {
      let timeValue = parseInt(value.slice(0, 2));
      if (timeValue >= 12) {
        return "pm";
      } else {
        return "am";
      }
    },
    createSubscription() {
      this.createModel.subscriptionProfessionalId = this.singleProfessional.professionalId;
      this.createModel.subscriptionCustomerId = this.userInfo.customerId;
      this.createModel.subscriptionType = this.subType;
      this.createModel.subscriptionStartTime = this.selectedSubSlot.availableTimeStartTime;
      this.createModel.subscriptionEndTime = this.selectedSubSlot.availableTimeEndTime;
      if (this.subType === "Monthly") {
        this.createModel.subscriptionAmount = this.profSubscriptions.monthlySubscriptionAmount;
      }
      if (this.subType === "Weekly") {
        this.createModel.subscriptionAmount = this.profSubscriptions.weeklySubscriptionAmount;
      }
      this.createModel.subscriptionDays = this.daysList;
      StoreUtils.dispatch("subscription/createSubscription", this.createModel);
    }
  }
};
</script>

<style scoped></style>
